// extracted by mini-css-extract-plugin
export var box = "D_vF";
export var btnBase = "D_d1";
export var boxBtn = "D_vG D_d1";
export var btnWrapper = "D_d2";
export var closeBtn = "D_vH D_d1";
export var boxIcon = "D_vJ";